import { useEffect, useMemo, useState } from "react";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import { DELETE_POP_UP, handleDownload, isValidObject, parseNumber } from "../../utils";
import { appApis, eSign, headerColumn, isInovize } from "../../constants";
import NewOrders from "./components/QuotationGenerate";
import { useApiRequest } from "../../hooks/useApiRequest";
import { RiDeleteBin5Line } from "react-icons/ri";
import { shallowEqual, useSelector } from "react-redux";
import { BsReceipt } from "react-icons/bs";

const QuotationPage = () => {
    const [state, setState] = useState({
        quotations: [],
        addQuotation: false,
        search: "",
        current: 1,
        total: 1
    });
    const { addQuotation, quotations, current, total, search } = state;
    const { request, loading } = useApiRequest();
    const { request: deleteRequest, loading: isDeleting } = useApiRequest();
    const { filters } = useSelector(({ inventory }) => ({ filters: inventory.filters }), shallowEqual);
    const billingCompanies = useMemo(() => filters?.billingCompanies || [], [filters]);

    const deleteQuotation = (quotationNo) => {
        DELETE_POP_UP(() => {
            deleteRequest({
                url: `${appApis.deleteQuotation}/${quotationNo}`,
                method: "DELETE",
                onSuccess: getQuotations
            })
        })
    }

    const downloadQuotation = (quotation) => {
        const fromCompany = billingCompanies?.find(item => item?.id == quotation?.from_company_id);
        const devices = quotation?.items?.map(item => ([{
            quantity: parseNumber(item?.quantity ?? 0),
            description: item?.description ?? "",
            amount: parseNumber(item?.per_piece_amount ?? 0)
        }])) ?? [];
        const gstType = quotation?.gst_type ?? "";
        const stamp = isInovize ? fromCompany?.companyStampUrl : eSign[String(fromCompany?.name ?? "").replaceAll(" ", "").toLowerCase() || "sbtracking"];
        const invoiceDetails = {
            fromCompany: {
                name: fromCompany?.name ?? "",
                address: fromCompany?.address ?? "",
                gst: fromCompany?.gstNumber ?? "",
                email: fromCompany?.email ?? "",
                phoneNo: fromCompany?.mobileNo ?? "",
                bankName: fromCompany?.bankName ?? "",
                branch: fromCompany?.branchName ?? "",
                accountNo: fromCompany?.bankAccountNo ?? "",
                ifscCode: fromCompany?.ifscCode ?? "",
                sacCode: isInovize ? fromCompany?.sacCode ?? "" : "998313",
                hsnCode: isInovize ? fromCompany?.hsnCode ?? "" : "852691",
                stampUrl: stamp,
                digitalSignatureUrl: isInovize ? fromCompany?.digitalSignatureUrl ?? "" : null
            },
            toCompany: {
                name: quotation?.quotated_company_name ?? "",
                gst: gstType == "GST" ? quotation?.gst_number ?? "" : "",
            },
            invoiceNo: quotation?.quotation_no ?? "",
            date: quotation?.quotation_date ?? "",
            vehicles: devices || [],
            amount: quotation.billing_amount ?? 0,
            gstAmount: quotation.gst_amount ?? 0,
            isComboCase: false,
            gstPercentage: gstType == "GST" ? 18 : 0
        }
        handleDownload(invoiceDetails, false, true);
    }

    const getQuotations = () => {
        const pageIndex = search ? 1 : current;
        request({
            url: appApis.getQuotation,
            method: "POST",
            showToast: false,
            body: { page: pageIndex, limit: 200, keyword: search },
            onSuccess: (response) => {
                const { data } = response;
                if (isValidObject(data)) {
                    setState(prev => ({ ...prev, quotations: data?.quotations ?? [], total: data?.total ?? 1, current: pageIndex }));
                }
            }
        })
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
    }

    useEffect(() => {
        getQuotations()
    }, [search, current])

    return <div className="vehicle-container">
        <SearchBox placeholder="Search for Quotation No/Company ..." className="mb-3" value={search} onChange={(e) => setState(prev => ({...prev, search: e.target.value, current: e.target?.value.length  }))} />
        <TableComponent col={4} breakPoint="lg" title={"Quotations"} headers={headerColumn.quotations} data={quotations} current={current} total={total} tableLoading={loading} paginationAction={paginationAction} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
           <td>{tdData?.quotation_no ?? "-"}</td>
            <td>{tdData?.quotated_company_name ?? "-"}</td>
            <td>{tdData?.quotation_date ?? "-"}</td>
            <td>{tdData?.from_company_name ?? "-"}</td>
            <td>{tdData?.gst_type ?? "-"}</td>
            <td>{tdData?.gst_number || "-"}</td>
            <td>{tdData?.items?.length ?? "-"}</td>
            <td>{tdData?.billing_amount ?? "-"}</td>
            <td>{tdData?.gst_amount ?? "-"}</td>
            <td>{tdData?.total_amount ?? "-"}</td>
            <td>
                <ButtonElement disabled={!tdData?.items?.length} text={<BsReceipt size={20} />} cssClass="more-radius mx-1" onClick={(e) => downloadQuotation(tdData)} variant="btn-outline-blue" loading={false} />
                <ButtonElement text={<RiDeleteBin5Line size={20} />} cssClass="more-radius px-4" onClick={() => deleteQuotation(tdData?.quotation_no ?? 0)} variant="btn-delete-icon" loading={isDeleting} />
            </td>
        </tr>} FilterComponent={<>
            <ButtonElement text={"Add Quotation"} cssClass="small-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, addQuotation: true }))} variant="btn-black" loading={false} />
        </>} />

        {addQuotation ? <NewOrders show={addQuotation} hideModal={() => setState(prev => ({ ...prev, addQuotation: false }))} onSuccess={getQuotations} billingCompanies={billingCompanies} inventoryTypes={filters?.inventoryTypes ?? []} /> : null}
    </div>
}

export default QuotationPage;